<template>
  <a-card>
    <span class="subtitle-2">Email Sending Options</span>
    <div>
      <input type="checkbox" v-model="sendEmailsIndividually" @change="() => updateSelection(this.value)" />
      <span class="caption ml-2">Send emails individually</span>
    </div>

    <v-row class="mx-2 py-2" justify="space-between">
      <span class="subtitle-2">Bookings</span>
    </v-row>

    <SupplierSearchBreakdown :searchRecord="searchRecord" />

    <div v-if="!bookingList.length">
      <span class="caption px-3">No Suppliers Assigned</span>
    </div>

    <BookingSupplierTable
      v-else
      :value="value"
      @input="(v) => updateSelection(v)"
      :dataList="bookingList"
      :searchRecord="searchRecord"
      :contactList="contacts"
      :loading="loading"
    />
    <br />
    <AdminAccountTable :value="value" :adminList="this.adminList" @input="(v) => updateSelection(v)" />
  </a-card>
</template>

<script>
import BookingSupplierTable from "./_BookingSupplierTable";
import SupplierSearchBreakdown from "../_SupplierSearchBreakdown";
import AdminAccountTable from "../_AdminAccountTable";

export default {
  props: {
    value: Object,
  },
  components: {
    BookingSupplierTable,
    SupplierSearchBreakdown,
    AdminAccountTable,
  },
  data() {
    return {
      selectAll: false,
      loading: false,
      searchRecord: null,
      bookingList: [],
      adminList: [],
      contacts: [],
      sendEmailsIndividually: false,
    };
  },
  methods: {
    updateSelection(value) {
      const updatedData = { ...value, sendEmailsIndividually: this.sendEmailsIndividually };
      this.$emit("input", updatedData);
    },
  },
  mounted() {
    this.loadingSuppliers = true;
    // Get query
    const savedTab = this.$store.getters["BookingEmailStore/activeTab"];
    const record = this.$store.getters["BookingEmailStore/" + savedTab + "Search"];

    this.searchRecord = record;

    // Existing query
    // List of suppliers + their contacts the user can select
    Promise.all([
      this.$store.dispatch("BookingEmailStore/getMassBookingContacts", record),
      this.$store.dispatch("AdminStore/getAccountList"),
    ])
      .then(([output1, output2]) => {
        this.loadingSuppliers = false;
        this.selected = {};

        this.bookingList = output1.bookings;
        this.contacts = output1.contacts;
        this.adminList = output2;

        this.$emit("setBookingRef", output1.bookings);
      })
      .catch((err) => {
        this.loadingSuppliers = false;
        this.$root.$error(err);
      });
  },
};
</script>
